<template>
    <div
        class="md-house gallery template4"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <module-box
            :fullColumn="true"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
        >
            <Grid
                :isGallery="true"
                :moreLink="moreLink"
                :moreText="moreText"
                :moreStyle="moreStyle"
                :moreLinkPurpose="moreLinkPurpose"
            />
            <MlsDesclaimer v-if="wordPressSSR" theme="fashion" />
        </module-box>
    </div>
</template>

<script>
import Core from '../index';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    mixins: [Core],
    components: { 
        Grid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v3_grid"*/ '../grid-v3/grid.vue'
            )),
        
    }
};
</script>
